﻿import WMSCapabilities from 'ol/format/WMSCapabilities';
import WMTSCapabilities from 'ol/format/WMTSCapabilities';

import { CapabilitiesResult, WMSLayer, TileMatrixSet, WMTSLayer } from "./LayerInterfaces";
import { ExternalLayerTypes } from "./LayerTypes";

export const getAutoSelectedMatrixSet = (sets: TileMatrixSet[]): string => {
    return autoSelectedMatrixSet(sets, ["EPSG:3857", "web_mercator", "webmercator", "web mercator", "EPSG:4326", "wgs84" ]);
}

const autoSelectedMatrixSet = (sets: TileMatrixSet[], names: string[]): string => {
    if (sets.length == 0)
        return "";

    for (var i = 0; i < names.length; i++) {
        let name = names[i].toLowerCase();
        let webmercatorSets = sets.filter(s => s.SupportedCRS.toLowerCase() === name || s.Identifier.toLowerCase() === name);
        if (webmercatorSets.length == 1)
            return webmercatorSets[0].Identifier;
    }

    return "";
}

export const getTileUrlFromCapabilitiesUrl = (capabilitiesUrl: string, layerType: ExternalLayerTypes) => {
    if (layerType === ExternalLayerTypes.WMTS) {
        let url = capabilitiesUrl.substring(0, capabilitiesUrl.toLowerCase().indexOf("wmts"));

        return url;
    }
    else
        return capabilitiesUrl.substring(0, capabilitiesUrl.indexOf("?"));
}

export const readCapabilitiesWms = async (capabilitiesUrl: string): Promise<CapabilitiesResult> => {
    const parser = new WMSCapabilities();

    try {
        const response = await fetch(capabilitiesUrl);
        if (!response.ok)
            throw "";

        try {
            let readCapabilities = parser.read(await response.text());
            let layers: WMSLayer[] = readCapabilities?.Capability?.Layer?.Layer ?? [];

            if (!layers.length)
                throw 'No layers found';

            return {
                layerType: ExternalLayerTypes.WMS,
                layers: layers
            };
        } catch (e) {
            throw "Unable to parse the capabilities";
        }
    } catch (e) {
        throw "Unable to fetch the capabilities";
    }
}

export const readCapabilitiesWmts = async (capabilitiesUrl: string): Promise<CapabilitiesResult> => {
    const parser = new WMTSCapabilities();

    try {
        const response = await fetch(capabilitiesUrl);
        if (!response.ok)
            throw "";

        try {
            let readCapabilities = parser.read(await response.text());
            let layers: WMTSLayer[] = readCapabilities?.Contents?.Layer ?? [];
            let sets: TileMatrixSet[] = readCapabilities?.Contents?.TileMatrixSet ?? [];

            if (!layers.length || !sets.length)
                throw 'No layers and/or sets found';

            return {
                layerType: ExternalLayerTypes.WMTS,
                layers: layers,
                matrixSets: sets
            };
        } catch (e) {
            throw "Unable to parse the capabilities";
        }
    } catch (e) {
        throw "Unable to fetch the capabilities";
    }
}
